// @generated by protoc-gen-connect-query v2.0.0 with parameter "import_extension=js"
// @generated from file services/source/api/source.proto (package gx.source.api, syntax proto3)
/* eslint-disable */

import { SourceService } from "./source_pb.js";

/**
 * Source CRUD
 *
 * @generated from rpc gx.source.api.SourceService.CreateSource
 */
export const createSource = SourceService.method.createSource;

/**
 * @generated from rpc gx.source.api.SourceService.GetSource
 */
export const getSource = SourceService.method.getSource;

/**
 * @generated from rpc gx.source.api.SourceService.ListSources
 */
export const listSources = SourceService.method.listSources;

/**
 * @generated from rpc gx.source.api.SourceService.UpdateSource
 */
export const updateSource = SourceService.method.updateSource;

/**
 * @generated from rpc gx.source.api.SourceService.DeleteSource
 */
export const deleteSource = SourceService.method.deleteSource;

/**
 * Internal-only: resolves Vault secrets. Not exposed through edge/OPA.
 *
 * @generated from rpc gx.source.api.SourceService.GetSourceWithCredentials
 */
export const getSourceWithCredentials = SourceService.method.getSourceWithCredentials;

/**
 * Retrieve a presigned URI for a uploaded file source
 *
 * @generated from rpc gx.source.api.SourceService.GetPresignedDownloadUri
 */
export const getPresignedDownloadUri = SourceService.method.getPresignedDownloadUri;

/**
 * Usage
 *
 * @generated from rpc gx.source.api.SourceService.GetTenantSourceUsage
 */
export const getTenantSourceUsage = SourceService.method.getTenantSourceUsage;

/**
 * @generated from rpc gx.source.api.SourceService.GetSourceUsage
 */
export const getSourceUsage = SourceService.method.getSourceUsage;
